/* eslint no-underscore-dangle: off */
const en = {
    clearAll: 'Reset',
    placeholder: 'Input highlighted keywords',
    splitNote: `Supports multiple keywords with the same color, each separated by semicolons.
  Use "xxx" for exact highlighting is supported for English keywords.`,
    add: 'Add Highlight'
};

const cn = {
    clearAll: '重置',
    placeholder: '请输入需高亮的词',
    splitNote: `支持多个关键词使用一个颜色高亮，可用分号";"分隔。
  英文关键词支持使用双引号""进行精准高亮。`,
    add: '新增高亮'
};

const jp = {
    clearAll: 'リセット',
    placeholder: 'キーワード入力',
    splitNote: `複数のキーワードを一色でハイライトを使用することができます。“;”で区分けすることができます。
  英語のキーワードを二重引用符（“ ”）で囲むと、完全一致のハイライトが表示される。`,
    add: 'ハイライト追加'
};

const tw = {
    clearAll: '重置',
    placeholder: '請輸入需高亮的詞',
    splitNote: `支持多個關鍵詞使用壹個顏色高亮，可用分號";"分隔。
  英文關鍵詞支持使用雙引號""進行精準高亮。`,
    add: '新增高亮'
};

const _en = { PtHighlightPanel: en };
const _cn = { PtHighlightPanel: cn };
const _jp = { PtHighlightPanel: jp };
const _tw = { PtHighlightPanel: tw };

export default {
    fallbackLocale: 'en',
    messages: {
        en: _en,
        cn: _cn,
        jp: _jp,
        tw: _tw,
        'en-US': _en,
        'zh-CN': _cn,
        'zh-TW': _tw,
        'ja-JP': _jp,
    },
};
